import { IconPropsType } from '..';

export const LotteryIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_119_2275)">
      <path d="M10.2411 9.17986L10.4929 9.42446L10.7447 9.17986C11.0037 8.92086 13.3203 6.65468 13.7807 5.89209C14.0828 5.39568 14.2195 4.89928 14.2195 4.28777C14.2195 2.78417 13.09 2 11.9749 2C11.3634 2 10.8526 2.20863 10.4929 2.60432C10.2195 2.30216 9.75911 2 9.0181 2C7.69436 2 6.7735 2.94245 6.7735 4.28777C6.7735 4.89928 6.91019 5.39568 7.21235 5.89209C7.68717 6.65468 9.98213 8.92806 10.2411 9.17986Z" />
      <path d="M10.759 10.813L10.5072 10.5684L10.2554 10.813C9.99641 11.072 7.67986 13.3381 7.21943 14.1007C6.91727 14.5971 6.78058 15.0935 6.78058 15.7051C6.78058 17.2087 7.91007 17.9928 9.02518 17.9928C9.63669 17.9928 10.1475 17.7842 10.5072 17.3885C10.7806 17.6907 11.241 17.9928 11.9892 17.9928C13.3058 17.9928 14.2266 17.0504 14.2266 15.7051C14.2266 15.0935 14.0899 14.5971 13.7878 14.1007C13.313 13.3453 11.018 11.072 10.759 10.813Z" />
      <path d="M17.8957 9.99278C18.1979 9.7194 18.5 9.25897 18.5 8.51077C18.5 7.19422 17.5576 6.27336 16.2123 6.27336C15.5936 6.27336 15.1043 6.41005 14.6079 6.71221C13.8453 7.17984 11.5792 9.4748 11.3202 9.73379L11.0756 9.98559L11.3202 10.2374C11.5792 10.4964 13.8453 12.8129 14.6079 13.2734C15.1043 13.5755 15.6007 13.7122 16.2123 13.7122C17.7159 13.7122 18.5 12.5827 18.5 11.4676C18.5 10.8633 18.2842 10.3525 17.8957 9.99278Z" />
      <path d="M9.67986 10.259L9.92446 10.0072L9.67986 9.75541C9.42086 9.49641 7.15468 7.17987 6.39209 6.71943C5.89568 6.41728 5.39928 6.28059 4.78777 6.28059C3.28417 6.27339 2.5 7.40289 2.5 8.518C2.5 9.12951 2.70863 9.6403 3.10432 10C2.80216 10.2806 2.5 10.741 2.5 11.482C2.5 12.7986 3.44245 13.7194 4.78777 13.7194C5.40647 13.7194 5.89568 13.5827 6.39209 13.2806C7.15468 12.813 9.42806 10.518 9.67986 10.259Z" />
      <path d="M14.2195 13.7195C16.5648 17.4965 18.4929 17.9425 18.4929 17.9425V16.8634C18.5001 16.8706 16.3346 16.3958 14.2195 13.7195Z" />
    </g>
    <defs>
      <clipPath id="clip0_119_2275">
        <rect
          width="16"
          height="16"
          transform="translate(2.5 2)"
        />
      </clipPath>
    </defs>
  </svg>
);
